<app-menu-riot></app-menu-riot>
<div class="container">
    <div class="program-title">Programme de cette édition</div>
    <div class="program-cards">
        <div class="d-flex flex-wrap justify-content-around">
            <!--Jour 1-->
            <div class="card col-sm-12 col-md-5">
                <div class="card-body">
                    <h5 class="card-title">Lundi 24 mai</h5>
                    <hr>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                            <p class="card-hour">17:00 - 17:30</p>
                            <p class="card-event">Pre Show event</p>
                            <p>On vous dévoile tout sur le Play For Good</p>
                        </li>
                        <li class="list-group-item">
                            <p class="card-hour">17:30 - 19:00</p>
                            <p class="card-event">Conférence - Play For Handicap International</p>
                            <p>Xavier Du Crest, le directeur d'Handicap International vous expliquera les missions de
                                l'association</p>
                        </li>
                        <li class="list-group-item">
                            <p class="card-hour">19:30 - 23:00</p>
                            <p class="card-event">LOR Phase de Poule</p>
                        </li>
                        <li class="list-group-item">
                            <p class="card-hour">23:00 - 23:30</p>
                            <p class="card-event">Interview + Clôture</p>
                        </li>
                    </ul>
                </div>
            </div>

            <!--Jour 2-->
            <div class="card col-sm-12 col-md-5">
                <div class="card-body">
                    <h5 class="card-title">Mardi 25 mai</h5>
                    <hr>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                            <p class="card-hour">17:30 - 19:00</p>
                            <p class="card-event">Conférence - Le Jeu vidéo et l'e-sport comme vecteur de partage et d'inclusion</p>
                            <p>On réserve un panel légendaire</p>
                        </li>
                        <li class="list-group-item">
                            <p class="card-hour">19:00 - 20:00</p>
                            <p class="card-event">Animation</p>
                            <p>Surprise !</p>
                        </li>
                        <li class="list-group-item">
                            <p class="card-hour">20:00 - 00:00</p>
                            <p class="card-event">TFT - Phase de poule</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="d-flex flex-wrap justify-content-around">
            <!--Jour 3-->
            <div class="card col-sm-12 col-md-5">
                <div class="card-body">
                    <h5 class="card-title">Mercredi 26 mai</h5>
                    <hr>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                            <p class="card-hour">16:30 - 18:00</p>
                            <p class="card-event">Conférence - Les métiers du jeu vidéo</p>
                        </li>
                        <li class="list-group-item">
                            <p class="card-hour">18:00 - 00:00</p>
                            <p class="card-event">LOL - Phase de poule</p>
                        </li>
                    </ul>
                </div>
            </div>

            <!--Jour 4-->
            <div class="card col-sm-12 col-md-5">
                <div class="card-body">
                    <h5 class="card-title">Jeudi 27 mai</h5>
                    <hr>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                            <p class="card-hour">18:00 - 19:30</p>
                            <p class="card-event">LOR Arbre éliminatoire 1ère partie</p>
                        </li>
                        <li class="list-group-item">
                            <p class="card-hour">19:30 - 20:30</p>
                            <p class="card-event">Animation</p>
                            <p>Surprise !</p>
                        </li>
                        <li class="list-group-item">
                            <p class="card-hour">20:30 - 23:30</p>
                            <p class="card-event">LOR Arbre éliminatoire 2ème partie</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="d-flex flex-wrap justify-content-around">
            <!--Jour 5-->
            <div class="card col-sm-12 col-md-5">
                <div class="card-body">
                    <h5 class="card-title">Vendredi 28 mai</h5>
                    <hr>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                            <p class="card-hour">17:00 - 23:00</p>
                            <p class="card-event">LOL - Arbre éliminatoire</p>
                        </li>
                    </ul>
                </div>
            </div>

            <!--Jour 6-->
            <div class="card col-sm-12 col-md-5">
                <div class="card-body">
                    <h5 class="card-title">Samedi 29 mai</h5>
                    <hr>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                            <p class="card-hour">11:30 - 12:30</p>
                            <p class="card-event">Animation</p>
                            <p>Surprise !</p>
                        </li>
                        <li class="list-group-item">
                            <p class="card-hour">13:00 - 18:00</p>
                            <p class="card-event">LOR - Phases finales</p>
                        </li>
                        <li class="list-group-item">
                            <p class="card-hour">18:30 - 22:30</p>
                            <p class="card-event">TFT - Phases finales</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="d-flex flex-wrap justify-content-around">
            <!--Jour 7-->
            <div class="card col-sm-12 col-md-5">
                <div class="card-body">
                    <h5 class="card-title">Dimanche 30 mai</h5>
                    <hr>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                            <p class="card-hour">12:30 - 13:30</p>
                            <p class="card-event">Animation</p>
                            <p>Surprise !</p>
                        </li>
                        <li class="list-group-item">
                            <p class="card-hour">14:00 - 22:00</p>
                            <p class="card-event">LOL - Phases finales</p>
                        </li>
                        <li class="list-group-item">
                            <p class="card-hour">22:00 - 23:00</p>
                            <p class="card-event">Final Show</p>
                            <p>Parce que tout plaisir à une fin ;)</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<app-scroll-to-top></app-scroll-to-top>
<app-footer></app-footer>
